module.exports = __webpack_public_path__ + "static/media/logo-arbitr-full.5a0cffdb.svg";